import { AgentMessage } from '~/features/ask-anything/agentic-ai/types';
import { sylvanus } from '~/services/serviceInstances';

import { mapUserRatingFromFeedbackDetails } from '../../transformers/conversationalAi';
import {
  AgentExecutionMessage,
  UpdateAgentExecutionMessageRequest,
} from '../../types/sylvanus/agentExecution';
import { mapServerAgentExecutionMessageToAgentExecutionMessage } from './transformers';

type Request = {
  agentExecutionId: string;
  messageId: string;
  feedbackDetails: AgentMessage['feedbackDetails'];
};

export const patchAgentExecutionMessage = async ({
  agentExecutionId,
  messageId,
  feedbackDetails,
}: Request): Promise<AgentMessage> => {
  const response = await sylvanus.patch<AgentExecutionMessage>(
    `/agent-execution/${agentExecutionId}/message/${messageId}`,
    mapFeedbackDetailsToUpdateRequest(feedbackDetails),
  );

  return mapServerAgentExecutionMessageToAgentExecutionMessage(response);
};

const mapFeedbackDetailsToUpdateRequest = (
  feedbackDetails: AgentMessage['feedbackDetails'],
): UpdateAgentExecutionMessageRequest => {
  return {
    user_rating: mapUserRatingFromFeedbackDetails(feedbackDetails),
    user_comment: feedbackDetails?.comment,
    user_feedback_category: feedbackDetails?.category,
  };
};
